import { useState, useEffect, useCallback } from "react";
import { Table } from "react-bootstrap";
import CustomerFooter from "./CustomerFooter";
import HeaderCustomer from "./HeaderCustomer";
import './Customer.css';
import * as XLSX from 'xlsx';
import ApiHandler from "../../ApiHandler";
import TransferData from "../../TransferData";
import LoaderTri from "../Loader/LoaderTri";

export default function PendingBills() {

    const [showPendingBillData, setShowPendingBillData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchError, setFetchError] = useState(false);

    const fetchPendingBills = useCallback((retryCount = 0) => {
        setIsLoading(true);
        setFetchError(false);
        const localUrl = JSON.parse(localStorage.getItem('LocalURL'));
        const user = JSON.parse(localStorage.getItem('user-info'));
        ApiHandler.post({
            url: localUrl + "api/OwnApp/GetPendingBill",
            data: { code: user.code },
            useUserUrl: true
        })
            .then((result) => {
                setShowPendingBillData(result.data);
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response.status === 401) {
                    console.log(err.response);
                } else if (retryCount < 2) {
                    setTimeout(() => fetchPendingBills(retryCount + 1), 3000);
                    return;
                } else {
                    setFetchError(true);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        fetchPendingBills();
    }, [fetchPendingBills]);

    function handleExportDataExcel() {
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(showPendingBillData);
        XLSX.utils.book_append_sheet(wb, ws, "MySheet1");
        XLSX.writeFile(wb, "Reports.xlsx");
    }

    return (
        <>
            <HeaderCustomer />

            <div style={{ minHeight: window.innerHeight / 1.3 }}>

                <div className="d-flex justify-content-center">
                    <div className="pendingBillData">

                        <div className="row m-0">
                            <div className="col-lg-6 offset-lg-3">
                                <div className="pendingBill row">
                                    <div className="col-6 col-lg-6">
                                        <h4>Pending Bills</h4>
                                    </div>
                                    {showPendingBillData.length > 0 && (
                                        <div className="col-6 col-lg-6 text-end">
                                            <button onClick={handleExportDataExcel}>Download</button>
                                        </div>
                                    )}
                                </div>

                                {fetchError && !isLoading && (
                                    <div className="d-flex flex-column align-items-center" style={{ padding: "20px", gap: "10px" }}>
                                        <p style={{ color: "red", margin: 0 }}>Failed to load pending bills.</p>
                                        <button onClick={() => fetchPendingBills()}>Retry</button>
                                    </div>
                                )}

                                <div style={{ width: "100%", overflowX: "scroll" }}>
                                    <Table striped>
                                        <thead className="threAd">
                                            <tr className="threAd_tr">
                                                <th>{TransferData.billDate}</th>
                                                <th>{TransferData.billNo}</th>
                                                <th>{TransferData.amount}</th>
                                                <th>{TransferData.pending}</th>
                                                <th>{TransferData.duedate}</th>
                                                <th>{TransferData.runningTotal}</th>
                                                <th>{TransferData.days}</th>
                                            </tr>
                                        </thead>
                                        {showPendingBillData.map((elm, index) => (
                                            <tbody className="tboDY" key={index}>
                                                <tr>
                                                    <td style={{ color: elm._Color === "Y" ? '#ff9999' : '' }}>{elm.billDate}</td>
                                                    <td style={{ color: elm._Color === "Y" ? '#ff9999' : '' }}>{elm.billNo}</td>
                                                    <td style={{ color: elm._Color === "Y" ? '#ff9999' : '', textAlign: "right" }}>{elm.amount}</td>
                                                    <td style={{ color: elm._Color === "Y" ? '#ff9999' : '', textAlign: "right" }}>{elm.pending}</td>
                                                    <td style={{ color: elm._Color === "Y" ? '#ff9999' : '' }}>{elm.duedate}</td>
                                                    <td style={{ color: elm._Color === "Y" ? '#ff9999' : '' }}>{elm.runningTotal}</td>
                                                    <td style={{ color: elm._Color === "Y" ? '#ff9999' : '' }}>{elm.days}</td>
                                                </tr>
                                            </tbody>
                                        ))}
                                    </Table>
                                </div>
                            </div>
                        </div>

                        {isLoading && (
                            <div className="d-flex justify-content-center">
                                <LoaderTri />
                            </div>
                        )}
                    </div>
                </div>

            </div>
            <CustomerFooter />
        </>
    );
}
